<template>
  <div class="mainCon">
    <div class="contbanner standbymain">
      <div class="mainDivWidth flexDiv stanmain">
        <div class="stanLeft wow fadeInLeft animated">
          <div class="scene-Header">
            <div class="flexDiv">
              <div class="stancont">
                <p class="sceneTitle">分享裂变</p> 
                <p class="backtxt">大量获取用户流量</p>
              </div>
              <p class="explantxt">通过微信等渠道分享活动，大量获取用户参与量。</p>
              <div class="startban">
                <p>推荐指数：</p>
                <img src="static/img/activity/start.png" alt="">
                <img src="static/img/activity/start.png" alt="">
                <img src="static/img/activity/start.png" alt="">
                <img src="static/img/activity/start.png" alt="">
              </div>
            </div>
          </div>
        </div>
        <div class="stanRight wow fadeInRight animated">
          <img src="static/img/activity/actShare/bannerpic.png" alt="">
        </div>
      </div>
    </div>
    <div class="conticon">
      <div class="mainDivWidth flexDiv conmains">
        <div class="ditchList wow zoomIn animated" v-for="conlis in conticonList" @click="changeanchorId(conlis.id)">
          <img :src="conlis.pic" alt="">
          <p>{{conlis.title}}</p>
        </div>
      </div>
    </div>
    <section  id="recommend">
      <div class="mainDivWidth">
        <h3 class="sectionTitle">推荐理由</h3>
        <div class="recommend flexDiv">
          <div v-for="rec in recomList"  class="recomlist">
            <img :src="rec.icons" alt="">
            <div class="recomtxt">
              <p>{{rec.title}}</p>
              <span>{{rec.cont}}</span>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="contbg" id="contbg">
      <div class="mainDivWidth">
        <h3 class="sectionTitle whiteText">活动数据</h3>
        <div class="flexDiv actDatamain">
          <div class="activedata" v-for="actl in activedatas">
            <p>{{actl.nums}}</p>
            <span>{{actl.explain}}</span>
          </div>
        </div>
      </div>
    </section>
    <section id="flowPath">
      <div class="mainDivWidth">
        <h3 class="sectionTitle">活动流程</h3>
        <div class="flexDiv flowpics">
          <img src="static/img/activity/actShare/flowpic/flowpic01.png" alt="">
          <img class="direct" src="static/img/activity/dirsmall.png" alt="">
          <img src="static/img/activity/actShare/flowpic/flowpic02.png" alt="">
          <img class="direct" src="static/img/activity/dirsmall.png" alt="">
          <img src="static/img/activity/actShare/flowpic/flowpic03.png" alt="">
          <img class="direct" src="static/img/activity/dirsmall.png" alt="">
          <img src="static/img/activity/actShare/flowpic/flowpic04.png" alt="">
        </div>
      </div>
    </section>
    <section  id="actCase">
      <div class="casebg">
        <div class="mainDivWidth">
          <h3 class="sectionTitle whiteText">活动案例</h3>
          <div class="flexDiv casecont">
            <img class="wow rotateInDownRight animated" src="static/img/activity/actShare/casepic/casepic01.png" alt="">
            <img class="wow rotateInDownRight animated" src="static/img/activity/exchange/caseicon/caseicon02.png" alt="">
            <img class="wow rotateInDownRight animated" src="static/img/activity/exchange/caseicon/caseicon03.png" alt="">
          </div>
        </div>
      </div>
    </section>
    
    <section>
      <div class="mainDivWidth">
        <h3 class="sectionTitle">我们还可以做到</h3>
        <div class="flexDiv maskcont">
          <div class="maskban wow bounceIn animated" v-for="mas in maskList">
            <img :src="mas.pics" alt="">
            <p>{{mas.title}}</p>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { WOW } from "wowjs";
export default {
  name: 'actShare',
  data:function(){
    return {
      conticonList:[
        {
          id:"recommend",
          title:"推荐理由",
          pic:"static/img/activity/standby/icon-2/logo01.png"
        },
        {
          id:"contbg",
          title:"活动数据",
          pic:"static/img/activity/standby/icon-2/logo02.png"
        },
        {
          id:"flowPath",
          title:"活动流程",
          pic:"static/img/activity/standby/icon-2/logo03.png"
        },
        {
          id:"actCase",
          title:"活动案例",
          pic:"static/img/activity/standby/icon-2/logo04.png"
        },
      ],
      recomList: [
        {
          icons:"static/img/activity/actShare/iconpic01.png",
          title:"大量获取用户流量",
          cont:"通过分享获取用户浏览，层级分裂，高流量浏览"
        },
        {
          icons:"static/img/activity/standby/icon-1/actstan03.png",
          title:"分裂快速高效",
          cont:"多渠道分享方式，让分裂速度快捷高效。"
        },
        {
          icons:"static/img/activity/standby/icon-1/actstan05.png",
          title:"增量效果显著",
          cont:"大量圈拢用户，显著提升活跃用户量。"
        }
      ],
      activedatas:[
        {
          nums:"20个+", 
          explain:"活动数量"
        },
        {
          nums:"200万人次+", 
          explain:"参与人数"
        },
        {
          nums:"2700万元+", 
          explain:"优惠金额"
        },
        {
          nums:"1000万元+", 
          explain:"交易金额"
        }
      ],
      maskList:[
        {
          pics:"static/img/activity/actAdminSend/maspic/maspic01.png",
          title:"白名单发券（手机号/银行卡号）",
        },
        {
          pics:"static/img/activity/actAdminSend/maspic/maspic02.png",
          title:"指定银行卡类别/卡并领取",
        }, 
        {
          pics:"static/img/activity/actAdminSend/maspic/maspic03.png",
          title:"指定手机号归属地领取",
        },
        {
          pics:"static/img/activity/actAdminSend/maspic/maspic04.png",
          title:"指定渠道/商户核销使用",
        }
      ]
    }
  },
  mounted() {
    var wow = new WOW({
      boxClass: "wow",
      animateClass: "animated",
      offset: 0,
      mobile: true,
      live: false
    });
    wow.init();
  },
  methods: {
    changeanchorId(id) {
      $("html, body").animate({ scrollTop: $("#" + id).offset().top }, 1000);
      this.backTop = true;
      return false; // 返回false可以避免在原链接后加上#
    },
  }
}
</script>
<style scoped lang="scss">
  @import "../../assets/css/activityClass/actshare";
</style>



// WEBPACK FOOTER //
// src/pages/activityTypePage/activity8-share.vue